import * as React from "react";
import type { SVGProps } from "react";
const SvgSmallCheckmark = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24" {...props}
  >
    <path d="m15.333 10.332-4.167 4.167-2.5-2.5" color="#42AE5C" />
  </svg>
);
export default SvgSmallCheckmark;
